module.exports = __webpack_public_path__ + "img/gld_gbt818_2000.prt.8ea47262.jpg";